document.addEventListener("DOMContentLoaded", () => {
  const likes = document.querySelectorAll(".col-item-like");

  // 从本地存储中加载已点赞状态
  function loadLikeStates() {
    const savedLikes = localStorage.getItem("likedItems");
    return savedLikes ? JSON.parse(savedLikes) : {};
  }

  // 保存点赞状态到本地存储
  function saveLikeStates(states) {
    localStorage.setItem("likedItems", JSON.stringify(states));
  }

  const likeStates = loadLikeStates();

  // 恢复之前的点赞状态
  likes.forEach(function (item, index) {
    const itemId = item.id || `like-${index}`;

    if (likeStates[itemId]) {
      item.classList.add("active");
      const numItem = item.querySelector(".col-item-like-num");
      numItem.innerText = likeStates[itemId];
    }

    // 取消或添加点赞
    item.addEventListener("click", function () {
      const numItem = item.querySelector(".col-item-like-num");
      const currentNum = parseInt(numItem.textContent);

      if (item.classList.contains("active")) {
        item.classList.remove("active");
        const newNum = currentNum - 1;
        numItem.innerText = newNum;
        delete likeStates[itemId];
      } else {
        item.classList.add("active");
        const newNum = currentNum + 1;
        numItem.innerText = newNum;
        likeStates[itemId] = newNum;
      }

      saveLikeStates(likeStates);
    });
  });
});
